import { AlertService } from './shared/services/alert.service';
import { UsuarioModel } from './models/usuario.model';
import { GlobalService } from './shared/global.service';
import { Component, OnInit } from '@angular/core';
import { UrlService } from './shared/services/url.service';
import { UrlControl } from './shared/models/generic.model';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstantesService } from './shared/services/constantes.service';
import { ConnectionService } from 'ng-connection-service';
import { AppSettings } from './app.settings';
import { InitFrontModel } from './models/initFront.model';

declare var jQuery: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public title = 'DemoAccesibilidad';
  public idioma = 'Español';
  public tamanoletra: number;
  public style: any;
  public iconDemo: string;
  public tamanoletras: any = null;
  public modificacionmenu: any;
  public modificacioncontenido: any;
  public idiomas: any;
  public imageuser: string;
  public iconomenColor: string;
  public iconomenDark: string;
  public username: string;
  public hidden: any;
  public escogerRol: boolean;
  public menuprincipal: boolean;
  private fechaExpiracionToken = null;
  private usuario: UsuarioModel;
  private callValidateToken: any;
  public contadorUac = 0;
  private listaPermisos: any[];
  status = 'ONLINE';
  isConnected = true;

  constructor(
      private global: GlobalService
    , private urlService: UrlService
    , private alertService: AlertService
    , private route: ActivatedRoute
    , private router: Router
    , private connectionService: ConnectionService
  ) {
    this.validarIngreso();
    this.global.contadorUAC.subscribe((nextvalue: any) => {
      this.contadorUac = nextvalue;
    });
    this.usuario = new UsuarioModel('', '', '', '', '');
    /* this.callValidateToken = setInterval(() => {
      this.validarVigenciaToken();
    }, 5000); */
    this.validarConexionAplicacion();
  }

  ngOnInit() {
    this.getUrlsAplication();
  }

  /**
   * obtiene las rutas iniciales que debe consumir el front
   * @author fromero
   */
  private getUrlsAplication() {

    const serviceProvider = 'InitAplication';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), AppSettings.API_INIT_ENDPOINT);
    this.global.getSIA3(url)
      .subscribe(rutas => {
        this.urlService.setApiAcvis(rutas.urlAcvis);
        this.urlService.setApiUac(rutas.urlUAC);
        this.urlService.setApiFuncionarios(rutas.urlFuncionarios);
        this.urlService.setApiWebSocketTurnos(rutas.urlWebSocket);
		this.urlService.setApiCargueMasivo(rutas.urlCargueService);
      }, error => {
        this.alertService.generateAlertError('Ocurrio un error al consumir el servicio de rutas de aplciación', 'Error');
        this.router.navigate(['/not-found']);
      });
  }

  /**
   * cosume la información de la aplicación
   */
  initFrontSIA3() {
    if (!sessionStorage.getItem('idAplicacion')) {
      const serviceProvider = 'Init';
      const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
      this.global.getSIA3(url)
        .subscribe(params => {
          sessionStorage.setItem('idAplicacion', params.idAplicacion);
          sessionStorage.setItem('urlLogin', params.urlLogin);
          sessionStorage.setItem('urlBase', params.urlBase);
          sessionStorage.setItem('urlParametros', params.urlParametros);
          this.validarTokenExistente();
        }, error => {
          if (location.hash.indexOf('agenda-virtual') >= 0) {
            window.close();
          } else {
            this.alertService.generateAlertError('Ocurrio un error al consumir el servicio Init', 'Error');
            this.regresarLogin();
          }
        });
    } else {
      this.validarTokenExistente();
    }
  }

  validarIngreso() {
    if (this.validarRutas()) {
      this.initFrontSIA3();
    }
  }

  validarRutas() {
    const noExcluidas = ConstantesService.LISTA_RUTAS_EXCLUIDAS.filter(ruta => location.hash.indexOf(ruta) < 0);
    return noExcluidas.length === ConstantesService.LISTA_RUTAS_EXCLUIDAS.length;
  }

  public validarTokenExistente() {
    const usuario = JSON.parse(sessionStorage.getItem('Usuario'));
    const token = sessionStorage.getItem('Token');
    const expiracion = new Date(Date.parse(sessionStorage.getItem('expiracionToken')));
    if (token && expiracion > new Date() && usuario && usuario.roles != null && usuario.roles.length > 0) {
      this.global.usuario = usuario;
      this.global.rolSeleccionado = sessionStorage.getItem(ConstantesService.ROL_SESSION_SIA3);
      this.fechaExpiracionToken = expiracion;
      this.validarPermisos();
    } else {
      // const code = '#/?code=ZIdnT2nEdiBXs0LA&user_id=2';
      // cambiar para entrega
      const code = location.hash;
      if (code.includes('#/?code')) {
        const cadena = code.replace('#/?', '');
        const parametros = cadena.split('&');
        this.validarParametros(parametros);
        const params = parametros[0].split('=');
        this.validarParametros(params);
        const params2 = parametros[1].split('=');
        this.validarParametros(params2);
        this.obtenerToken(params[1], sessionStorage.getItem('idAplicacion'), params2[1]);
      } else {
        this.regresarLogin();
      }
    }
  }

  validarParametros(parametros: string[]) {
    if (parametros.length < 2) {
      this.regresarLogin();
    }
  }

  regresarLogin() {
    // this.router.navigate(['/rol']);
    // cambiar para entrega
    const urlLogin = sessionStorage.getItem('urlLogin') ? sessionStorage.getItem('urlLogin') : 'http://www.google.com';
    window.location.href = urlLogin;
  }

  obtenerToken(codigo: string, idAplicacion: string, userId: string) {
    const queryParams = '?codigo_autorizacion=' + codigo + '&client_id=' + idAplicacion + '&user_id=' + userId;
    const url = sessionStorage.getItem('urlBase') + ConstantesService.AUTENTICACION_RESOURCE
      + ConstantesService.TOKEN_RESOURCE + queryParams;
    this.global.apiKey = idAplicacion;
    this.global.userId = userId;
    sessionStorage.setItem(ConstantesService.SIA3_SESSSION, userId);
    this.global.getSIA3(url).subscribe(
      data => {
        sessionStorage.setItem('Token', data.tokenAcceso);
        sessionStorage.setItem('expiracionToken', data.fechaExpiracion);
        this.fechaExpiracionToken = new Date(data.fechaExpiracion);
        this.getPermisosRol();
      }, err => {
        this.alertService.generateAlertError('Ocurrio un Error al Obtener Token', 'Error');
        this.regresarLogin();
      }
    );
  }

  validarVigenciaToken() {

    const fecha = new Date();
    this.fechaExpiracionToken = new Date(Date.parse(sessionStorage.getItem('ExpiracionToken')));
    if (this.fechaExpiracionToken != null) {
      if (this.fechaExpiracionToken < fecha) {
        //  var modalRef =  this.modalService.open(ConfirmationModalTokenComponent, { centered: true, size: 'lg' });
        clearInterval(this.callValidateToken);

        // modalRef.result.then

      }
    }
  }

  getPermisosRol() {

    const url = sessionStorage.getItem('urlBase') + ConstantesService.AUTENTICACION_RESOURCE + ConstantesService.ROLES_PERMISOS_RESOURCE;
    this.global.postSIA3(url).subscribe(
      data => {
        this.usuario.userid = data.usuario.userId;
        this.usuario.nombre = data.usuario.nombres;
        this.usuario.apellidos = data.usuario.apellidos;
        this.usuario.roles = data.permisos.roles;
        this.usuario.permisos = data.permisos.permisos;
        this.global.usuario = this.usuario; // Se guarda el usuario en variable global
        sessionStorage.setItem('Usuario', JSON.stringify(this.global.usuario));
        sessionStorage.setItem('roles', JSON.stringify(data.permisos.roles));
        this.validarPermisos();
        this.validarRol();
      }, err => {
        sessionStorage.removeItem('Token');
        sessionStorage.removeItem('expiracionToken');
        this.alertService.generateAlertError('Ocurrio un error al Obtener los permisos del usuario', 'Error');
        this.regresarLogin();
      }
    );
  }

  validarRol() {
    const roles: any[] = this.global.usuario.roles;
    if (roles.length > 0) {
      if (roles.length === 1) {
        this.global.rolSeleccionado = this.usuario.roles[0];
        sessionStorage.setItem(ConstantesService.ROL_SESSION_SIA3, this.usuario.roles[0]);
      }
      this.router.navigate(['/rol']);
    } else {
      this.alertService.generateAlertError('Se presentó un problema al cargar la aplicación', 'Error');
      this.regresarLogin();
    }
  }

  validarPermisos() {
    if (this.global.usuario && this.global.rolSeleccionado && !this.listaPermisos) {
      this.listaPermisos = [];
      this.cargarSubMenus(this.global.usuario.permisos);
      this.procesarPermisoElemento();
    }

    return new Promise((resolve, reject) => {
      this.validarPermisosAsync(200);
    });
  }

  cargarSubMenus(permisos) {
    // this.global.permisosUsuario = [];
    permisos.forEach(element => {
      if (element.nombreObjeto == '/') {
        element.nombreObjeto = '/main';
      }
      // if (element.nombreRolAsociado === this.global.rolSeleccionado) {
      //   this.global.permisosUsuario.push(element);
      // }
      if (element.tipo === 'BOTON'
        && element.nombreRolAsociado === this.global.rolSeleccionado) {
        this.listaPermisos.push(element.descripcion);
      }
      if (element.hijosOpcion && element.hijosOpcion.length > 0) {
        this.cargarSubMenus(element.hijosOpcion);
      }
    });
  }

  validarPermisosAsync(ms) {
    setTimeout(() => {
      this.validarPermisos();
    }, ms);
  }

  procesarPermisoElemento() {
    return new Promise((resolve, reject) => {
      jQuery('.visibilidad').each((index, element) => {
        if (this.listaPermisos.find(permiso =>
          permiso === jQuery(element).attr('id'))) {
          jQuery(element).hide();
        } else {
          jQuery(element).show();
        }
      });
    });
  }

  /**
   * valida el estado de conexión de la aplicación, si se pierde emite una alerta, y si se recupera recarga la paágina
   * @author fromero
   * 21/08/2019
   */
  validarConexionAplicacion() {
    this.connectionService.monitor().subscribe(isConnected => {
      this.isConnected = isConnected;
      if (this.isConnected) {
        this.status = 'ONLINE';
        this.global.setEstadoConexion(this.status);
        this.alertService.generateAlertSuccess('El sistema se ha recuperado de la perdida de conexión', '');

        location.reload();
      } else {
        this.status = 'OFFLINE';
        this.global.setEstadoConexion(this.status);
        this.alertService.generateAlertError(
          'Se perdió la conexión a internet, el sistema se recuperara cuando se reestablezca la conexión', 'Error');

      }
    });
  }
}
